import ParametrizacaoUtil from '../../utils/parametrizacao'

export default {  
    props: {
        value:{
            type: Object,
            required: true
        }
    }, 
    computed:{
        somenteLeitura(){
            return this.$route.params.id != null;
        }     
    },      
    methods: {
        getCodigoUnicoNaLista(array){
            return ParametrizacaoUtil.getCodigoUnicoNaLista(this.value, array);
        },
        getParametrizacaoAtributo(codigoUnicoAtributo){
            return ParametrizacaoUtil.getParametrizacaoAtributo(this.value, codigoUnicoAtributo);
        },          
        getValorAtributo(codigoUnicoAtributo){
            return ParametrizacaoUtil.getValorAtributo(this.value, codigoUnicoAtributo);
        }                      
    }
}